module.exports = __webpack_public_path__ + "media/34.f2d84123.mp3";